import { createSlice } from "@reduxjs/toolkit";
import {
  getImageFeedList,
  // deleteJump,
  // editJump,
  getJumpById,
  // getJumpList,
  getJumpPage,
  // postJump,
  // getJumpByRegionalId,
} from "../action/jumpAction";

const initialState = {
  dataJump: [],
  dataFeedJump: [],
  dataByIdJump: [],
  dataReportByIdJump: '',
  dataJumpByRegionalId: [],
  idJump: "",
  state: "",
  isOpenImageJump: false,
  isOpenDetailJumpPopup: false,
  isOpenForm: false,
  isLoading: false,
  isOpenPDF: false,
};
const jumpSlice = createSlice({
  name: "jump",
  initialState,
  reducers: {
    openForm: (state, action) => {
      state.isOpenForm = action.payload.open;
      state.state = action.payload.state;
      if (action.payload.state === "edit") {
        state.dataByIdJump = action.payload.data;
        state.idJump = action.payload.id;
      } else if (action.payload.state === "delete") {
        state.dataByIdJump = action.payload.data;
        state.idJump = action.payload.id;
      }
    },
    openImage: (state, action) => {
      state.isOpenImageJump = action.payload.open;
      state.state = action.payload.state;
      if (action.payload.state === "open") {
        state.dataByIdJump = action.payload.data;
        state.idJump = action.payload.id;
      } else if (action.payload.state === "close") {
        state.dataByIdJump = [];
        state.idJump = "";
      }
    },
    openPDF: (state, action) => {
      state.isOpenPDF = action.payload.open
    },
    openDetail: (state, action) => {
      if(action.payload.open){
        state.isOpenDetailJumpPopup = action.payload.open
        state.dataReportByIdJump = action.payload.data;
      } else {
        state.isOpenDetailJumpPopup = action.payload.open
        state.dataReportByIdJump = '';
      }
    },

  },
  extraReducers: {
    [getJumpPage.pending]: (state) => {
      state.isLoading = true;
    },
    [getJumpPage.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.dataJump = action.payload.data;
      state.isLoading = false;
    },
    [getJumpPage.rejected]: (state) => {
      state.isLoading = false;
    },
    [getImageFeedList.pending]: (state) => {
      state.isLoading = true;
    },
    [getImageFeedList.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.dataFeedJump = action.payload.data.content;
      state.isLoading = false;
    },
    [getImageFeedList.rejected]: (state) => {
      state.isLoading = false;
    },
    // [getJumpList.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [getJumpList.fulfilled]: (state, action) => {
    //   // console.log(action.payload);
    //   state.dataJump = action.payload.data
    //   state.isLoading = false
    // },
    // [getJumpList.rejected]: (state) => {
    //   state.isLoading = false
    // },
    [getJumpById.pending]: (state) => {
      state.isLoading = true;
    },
    [getJumpById.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.dataByIdJump = action.payload.data;
      state.isLoading = false;
    },
    [getJumpById.rejected]: (state) => {
      state.isLoading = false;
    },
    // [getJumpByRegionalId.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [getJumpByRegionalId.fulfilled]: (state, action) => {
    //   // console.log(action.payload)
    //   state.dataJumpByRegionalId = action.payload.data
    //   state.isLoading = false
    // },
    // [getJumpByRegionalId.rejected]: (state) => {
    //   state.isLoading = false
    // },
    // [postJump.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [postJump.fulfilled]: (state, action) => {
    //   // console.log(action.payload);
    //   state.isOpenForm = false
    //   state.isLoading = false
    // },
    // [postJump.rejected]: (state) => {
    //   state.isLoading = false
    // },
    // [editJump.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [editJump.fulfilled]: (state, action) => {
    //   state.isOpenForm = false
    //   state.isLoading = false
    //   state.dataByIdJump = []
    //   state.idJump = 0
    // },
    // [editJump.rejected]: (state) => {
    //   state.isLoading = false
    // },
    // [deleteJump.pending]: (state) => {
    //   state.isLoading = true
    // },
    // [deleteJump.fulfilled]: (state, action) => {
    //   state.isOpenForm = false
    //   state.isLoading = false
    //   state.dataByIdJump = []
    //   state.idJump = 0
    // },
    // [deleteJump.rejected]: (state) => {
    //   state.isLoading = false
    // },
  },
});

export const { openForm, openImage, openPDF, openDetail } = jumpSlice.actions;
export default jumpSlice.reducer;
